<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <a-form
        layout="horizontal"
        :model="formState"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        :rules="rules"
        @finish="handleSubmit"
      >
        <sdCards headless>
          <a-form-item name="entitas_id" label="Entitas" hidden>
            <a-input-number v-model:value="formState.entitas_id" placeholder="Masukkan Entitas" />
          </a-form-item>

          <a-row :gutter="24">
            <!-- Column 1 -->
            <a-col :span="12">
              <a-form-item name="year" label="Tahun">
                <a-input-number v-model:value="formState.year" placeholder="Masukkan Tahun" style="width: 100%" />
              </a-form-item>

              <a-form-item name="parent_id" label="Parent Indikator Kinerja">
                <a-select
                  placeholder="Pilih Parent Indikator Kinerja"
                  v-model:value="formState.parent_id"
                  show-search
                  :filter-option="filterSelect"
                  :disabled="true"
                >
                  <a-select-option v-for="option in options.kpiKorporat" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item name="name" label="Indikator Kinerja">
                <a-input v-model:value="formState.name" placeholder="Masukkan Indikator Kinerja" />
              </a-form-item>

              <a-form-item name="satuan_kpi_id" label="Satuan">
                <a-select placeholder="Pilih Satuan" v-model:value="formState.satuan_kpi_id" show-search>
                  <a-select-option v-for="option in options.satuan" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item v-if="formState.jenis_variable_kpi_id != 3" name="bobot" label="Bobot">
                <a-input-number :disabled="isTarget" v-model:value="formState.bobot" placeholder="Masukkan Bobot" />
              </a-form-item>
            </a-col>

            <!-- Column 2 -->
            <a-col :span="12">
              <a-form-item name="jenis_variable_kpi_id" label="Jenis Variable Indikator Kinerja">
                <a-select
                  :disabled="isTarget"
                  placeholder="Pilih Jenis Variable KPI"
                  v-model:value="formState.jenis_variable_kpi_id"
                  show-search
                >
                  <a-select-option v-for="option in options.jenisVariableKpi" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item v-if="formState.jenis_variable_kpi_id != 3" name="polarisasi" label="Polarisasi">
                <a-select
                  :disabled="isTarget"
                  placeholder="Pilih Polarisasi"
                  v-model:value="formState.polarisasi"
                  show-search
                >
                  <a-select-option v-for="option in options.polarisasi" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item name="max_pengurang" label="Maximal Pengurang" v-if="formState.jenis_variable_kpi_id == 3">
                <a-input-number
                  v-model:value="formState.max_pengurang"
                  placeholder="Masukkan Maximal Pengurang"
                  :min="0"
                />
              </a-form-item>

              <a-form-item
                name="target_nominal"
                label="Target KM"
                v-if="
                  formState.jenis_variable_kpi_id == 1 &&
                    formState.polarisasi != 'Rentang' &&
                    formState.polarisasi != 'Rentang 4 Titik'
                "
              >
                <a-input-number v-model:value="formState.target_nominal" placeholder="Masukkan Target Nominal" />
              </a-form-item>

              <a-form-item
                name="target_waktu"
                label="Target KM"
                v-if="
                  formState.jenis_variable_kpi_id == 2 &&
                    formState.polarisasi != 'Rentang' &&
                    formState.polarisasi != 'Rentang 4 Titik'
                "
              >
                <a-month-picker
                  v-model:value="formState.target_waktu"
                  placeholder="Pilih Bulan"
                  format="MM-YYYY"
                  valueFormat="YYYY-MM"
                />
              </a-form-item>

              <a-form-item name="target_manual" label="Target" v-if="formState.jenis_variable_kpi_id == 4">
                <a-textarea
                  v-model:value="formState.target_manual"
                  :auto-size="{ minRows: 3, maxRows: 6 }"
                  placeholder="Masukkan Target"
                />
              </a-form-item>

              <a-form-item
                name="target_nominal"
                label="Target Min KM"
                v-if="
                  formState.jenis_variable_kpi_id == 1 &&
                    (formState.polarisasi == 'Rentang' || formState.polarisasi == 'Rentang 4 Titik')
                "
              >
                <a-input-number v-model:value="formState.target_nominal" placeholder="Masukkan Target Nominal" />
              </a-form-item>

              <a-form-item
                name="target_nominal_max"
                label="Target Max KM"
                v-if="
                  formState.jenis_variable_kpi_id == 1 &&
                    (formState.polarisasi == 'Rentang' || formState.polarisasi == 'Rentang 4 Titik')
                "
              >
                <a-input-number
                  v-model:value="formState.target_nominal_max"
                  placeholder="Masukkan Target Max Nominal"
                />
              </a-form-item>

              <a-form-item v-if="formState.jenis_variable_kpi_id != 3" name="starting_month" label="Bulan Mulai">
                <a-select
                  :disabled="isTarget"
                  placeholder="Pilih Bulan Mulai"
                  v-model:value="formState.starting_month"
                  show-search
                  :filter-option="filterSelect"
                >
                  <a-select-option v-for="option in options.months" :key="option.index">
                    {{ option.full }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </sdCards>
        <sdCards title="Target Bulanan" v-if="formState.jenis_variable_kpi_id && formState.jenis_variable_kpi_id != 3">
          <!-- <a-row :gutter="24" style="margin-top: 20px">
              <a-col :span="24">
                <h1>Target Bulanan</h1>
              </a-col>
            </a-row> -->
          <a-row
            :gutter="24"
            style="margin-top: 20px"
            v-if="formState.polarisasi != 'Rentang' && formState.polarisasi != 'Rentang 4 Titik'"
          >
            <template v-for="month in options.months.slice(formState.starting_month - 1, 12)" :key="month.value">
              <a-col :span="8">
                <a-form-item :name="['monthly_targets', month.index]" :label="month.full">
                  <a-input-number
                    v-if="formState.jenis_variable_kpi_id == 1"
                    v-model:value="formState.monthly_targets[month.index]"
                    :placeholder="'Target ' + month.full"
                    style="width: 100%"
                    :disabled="isTarget"
                  />
                  <a-textarea
                    v-model:value="formState.monthly_targets[month.index]"
                    v-if="formState.jenis_variable_kpi_id == 4"
                    :auto-size="{ minRows: 3, maxRows: 6 }"
                    :placeholder="'Target ' + month.full"
                    :disabled="isTarget"
                  />
                </a-form-item>
              </a-col>
            </template>
          </a-row>
          <a-row
            :gutter="24"
            style="margin-top: 20px"
            v-if="
              formState.jenis_variable_kpi_id == 1 &&
                (formState.polarisasi == 'Rentang' || formState.polarisasi == 'Rentang 4 Titik')
            "
          >
            <template v-for="month in options.months.slice(formState.starting_month - 1, 12)" :key="month.value">
              <a-col :span="8">
                <span style="font-weight: bold;">{{ month.full }}</span>
                <a-form-item :name="['monthly_targets', month.index]" :label="'Min '">
                  <a-input-number
                    v-model:value="formState.monthly_targets[month.index]"
                    :placeholder="'Target Min ' + month.full"
                    style="width: 100%"
                    :disabled="isTarget"
                  />
                </a-form-item>
                <a-form-item :name="['monthly_targets_max', month.index]" :label="'Max '">
                  <a-input-number
                    v-model:value="formState.monthly_targets_max[month.index]"
                    :placeholder="'Target Max ' + month.full"
                    style="width: 100%"
                    :disabled="isTarget"
                  />
                </a-form-item>
                <a-form-item
                  v-if="formState.polarisasi == 'Rentang 4 Titik'"
                  :name="['monthly_batas_max', month.index]"
                  :label="'Batas Max '"
                >
                  <a-input-number
                    v-model:value="formState.monthly_batas_max[month.index]"
                    :placeholder="'Batas Max ' + month.full"
                    style="width: 100%"
                    :disabled="isTarget"
                  />
                </a-form-item>
                <a-divider />
              </a-col>
            </template>
          </a-row>
        </sdCards>
        <sdCards headless>
          <a-row>
            <a-col span="24">
              <div class="sDash_form-action" style="text-align: right;">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link :to="'/nko/kontrak'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </sdCards>
      </a-form>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../components/crud/style';
import { Main } from '../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import { DataService } from '@/config/dataService/dataService';

const KpiKorporatForm = {
  name: 'KpiKorporatForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);
    const dateObj = new Date();
    const isTarget = ref(false);

    const { months } = require('@/utility/monthsData');

    const dateState = reactive({
      month: params.month,
      year: params.year,
    });

    const modalState = reactive({
      isLoading: false,
      visible: false,
    });

    const formModalState = reactive({
      name: '',
      description: '',
    });

    const formState = reactive({
      starting_month: 1,
      entitas_id: params.entitas,
      parent_id: undefined,
      satuan_kpi_id: undefined,
      jenis_variable_kpi_korporat_id: undefined,
      name: '',
      bobot: null,
      target_nominal: null,
      target_nominal_max: null,
      target_waktu: '',
      target_manual: '',
      year: dateObj.getUTCFullYear(),
      polarisasi: undefined,
      formula: '',
      formula_description: '',
      variable_kpi_korporat_id: [],
      is_akumulasi: undefined,
      is_breakdown_target: undefined,
      max_pengurang: undefined,
      // Monthly target fields stored in an object
      monthly_targets: [],
      monthly_targets_max: [],
      monthly_batas_max: [],
    });

    const options = reactive({
      kpiKorporat: [],
      satuan: [],
      jenisVariableKpi: [],
      polarisasi: [
        {
          value: 'Positif',
          text: 'Positif',
        },
        {
          value: 'Negatif',
          text: 'Negatif',
        },
      ],
      months: months,
      variableKpiKorporat: [],
      akumulasi: [
        {
          value: false,
          text: 'Tidak',
        },
        {
          value: true,
          text: 'Ya',
        },
      ],
      breakdownTarget: [
        {
          value: false,
          text: 'Tidak',
        },
        {
          value: true,
          text: 'Ya',
        },
      ],
    });

    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const handleSubmit = values => {
      // console.log(values);
      if (values.target_waktu) {
        let my = values.target_waktu.split('-');
        values['target_waktu'] = my[0] + '-' + my[1] + '-' + '01';
      }

      if (props.mode == 'Tambah') {
        dispatch('axiosCrudSubmitDataRedirect', {
          url: 'kpi-korporat',
          data: values,
          redirect: '/nko/kontrak',
        });
      } else if (props.mode == 'Ubah') {
        dispatch('axiosDataUpdateRedirect', {
          id: params.id,
          url: 'kpi-korporat',
          data: values,
          redirect: '/nko/kontrak',
        });
      }
    };

    const rules = {
      name: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
      max_pengurang: [
        {
          required: true,
          type: 'number',
          min: 0,
          message: 'Angka tidak boleh negatif',
          trigger: 'change',
        },
      ],
    };

    const modalRules = {
      name: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
    };

    const filterSelect = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    onMounted(() => {
      // Initialize monthly_targets with empty values for each month
      options.months.forEach(month => {
        formState.monthly_targets[month.index] = undefined;
        formState.monthly_targets_max[month.index] = undefined;
      });

      dispatch('axiosCrudGetData', 'options-kpi-korporat').then(() => {
        options.kpiKorporat = crud.value;

        if (props.mode == 'Tambah') {
          formState.parent_id = parseInt(params.id);
        }
      });

      dispatch('axiosCrudGetData', 'options-satuan-kpi').then(() => {
        options.satuan = crud.value;
      });

      dispatch('axiosCrudGetData', 'options-jenis-variable-kpi').then(() => {
        options.jenisVariableKpi = crud.value;
      });

      if (props.mode == 'Ubah') {
        dispatch('axiosCrudGetData', 'options-variable-kpi-korporat-unused-owned/' + params.id).then(() => {
          options.variableKpiKorporat = crud.value;
        });

        const data = {
          url: 'kpi-korporat',
          id: params.id,
        };

        dispatch('axiosSingleDataGet', data).then(() => {
          Object.keys(crud.value).forEach(key => {
            formState[key] = crud.value[key];
          });
          if (crud.value.realisasi.length > 0) {
            isTarget.value = true;
          }
          for (let i = 1; i <= options.months.length; i++) {
            let monthIndex = 'monthly_targets,' + i;
            formState.monthly_targets[i] = crud.value[monthIndex];
            let monthIndexMax = 'monthly_targets_max,' + i;
            formState.monthly_targets_max[i] = crud.value[monthIndexMax];
            let batasMax = 'monthly_batas_max,' + i;
            formState.monthly_batas_max[i] = crud.value[batasMax];
          }
        });
      } else {
        dispatch('axiosCrudGetData', 'options-variable-kpi-korporat-unused').then(() => {
          options.variableKpiKorporat = crud.value;
        });
      }
    });

    const showModal = () => {
      modalState.visible = true;
    };

    const handleCancel = () => {
      modalState.visible = false;
    };

    const addVariable = () => {
      modalState.isLoading = true;

      DataService.post('variable-kpi-korporat', formModalState).then(() => {
        modalState.visible = false;
        modalState.isLoading = false;
        formModalState.name = '';
        formModalState.description = '';

        DataService.get('options-variable-kpi-korporat-unused').then(response => {
          options.variableKpiKorporat = response.data;
        });
      });
    };

    watch(
      () => formState.polarisasi,
      val => {
        if (val == 'Rentang') {
          formState.jenis_variable_kpi_id = 1;
          formState.is_akumulasi = false;
          formState.is_breakdown_target = false;
        }
        if (val == 'Rentang 4 Titik') {
          formState.target_nominal = 6;
          formState.target_nominal_max = 9;
          for (let i = formState.starting_month; i <= 12; i++) {
            formState.monthly_targets[i] = 6;
            formState.monthly_targets_max[i] = 9;
            formState.monthly_batas_max[i] = 15;
          }
        }
      },
    );

    watch(
      () => formState.jenis_variable_kpi_id,
      val => {
        if (val == 1) {
          options.polarisasi = [
            {
              value: 'Positif',
              text: 'Positif',
            },
            {
              value: 'Negatif',
              text: 'Negatif',
            },
            {
              value: 'Rentang',
              text: 'Rentang',
            },
            {
              value: 'Rentang 4 Titik',
              text: 'Rentang 4 Titik',
            },
          ];

          if (formState.polarisasi == 'Rentang') {
            formState.is_akumulasi = false;
            formState.is_breakdown_target = false;
          }
        } else {
          if (formState.polarisasi == 'Rentang') {
            formState.polarisasi = undefined;
          }

          options.polarisasi = [
            {
              value: 'Positif',
              text: 'Positif',
            },
            {
              value: 'Negatif',
              text: 'Negatif',
            },
          ];
        }
      },
    );

    watch(
      () => formState.is_akumulasi,
      val => {
        if (val == true) {
          if (formState.polarisasi == 'Rentang') {
            formState.polarisasi = undefined;
          }
        }
      },
    );

    watch(
      () => formState.is_breakdown,
      val => {
        if (val == true) {
          if (formState.polarisasi == 'Rentang') {
            formState.polarisasi = undefined;
          }
        }
      },
    );

    return {
      formState,
      labelCol,
      wrapperCol,
      handleSubmit,
      isLoading,
      rules,
      modalRules,
      filterSelect,
      options,
      modalState,
      showModal,
      handleCancel,
      addVariable,
      formModalState,
      dateState,
      isTarget,
    };
  },
};

export default KpiKorporatForm;
</script>

<style scoped>
.divider {
  border-right: 1px solid #578fca;
  padding-right: 16px;
}
</style>
